var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomepageBgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 807,
    height: 676,
    viewBox: "0 0 807 676",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3472 241.36C5.49122 161.464 -3.93679 121.516 1.97654 89.9222C11.684 38.0564 47.5958 -5.06421 96.8494 -23.9951C126.852 -35.527 167.847 -33.482 249.835 -29.392L765.14 -3.68615C839.68 0.0322227 876.949 1.89141 904.297 14.8661C949.155 36.148 980.791 77.997 989.035 126.958C994.06 156.808 985.686 193.172 968.938 265.9L916.533 493.464C902.554 554.167 895.565 584.519 881.058 606.944C857.297 643.673 818.863 668.385 775.584 674.759C749.162 678.651 718.646 672.414 657.616 659.939L234.055 573.36C192.728 564.912 172.064 560.688 154.519 552.049C125.85 537.932 102.359 515.139 87.3849 486.908C78.2212 469.631 73.3766 449.104 63.6874 408.05L24.3472 241.36Z",
    fill: "url(#paint0_linear_2413_4411)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2413_4411",
    x1: 74.4713,
    y1: 69.5,
    x2: 735.134,
    y2: 792.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4940CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D992DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageBgShape);
export default __webpack_public_path__ + "static/media/Homepage_bg_shape.f370aa04fae4bd6ef0479d4cbd421926.svg";
export { ForwardRef as ReactComponent };